import { createFileRoute } from "@tanstack/react-router";
import { ProtectedPage } from "../app/route-boundaries";
import { AdminAIPage } from "../pages/AdminAIPage";
export const Route = createFileRoute("/system/ai/playground")({
  component: () => (
    <ProtectedPage>
      <AdminAIPage section="playground" />
    </ProtectedPage>
  ),
});
